import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getMe, login as apiLogin, logout as apiLogout } from "../api/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("access_token");
    if (!token) { setLoading(false); return; }
    try {
      const res = await getMe();
      setUser(res.data.data);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("access_token");
      }
      // Network/server errors: don't invalidate a valid token
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (identifier, password) => {
    const res = await apiLogin(identifier, password);
    localStorage.setItem("access_token", res.data.data.access_token);
    const me = await getMe();
    setUser(me.data.data);
    return me.data.data;
  };

  const logout = async () => {
    try { await apiLogout(); } catch {}
    localStorage.removeItem("access_token");
    localStorage.removeItem("docmind:active_chat_id");
    setUser(null);
  };

  const refresh = useCallback(async () => {
    try {
      const res = await getMe();
      setUser(res.data.data);
      return res.data.data;
    } catch {
      return null;
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        refresh,
        isAdmin: user?.role === "admin",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
